const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTranscationSummaryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "url(#paint0_linear_1082_24991)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1082_24991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17.375H8.5C8.26802 17.3747 8.04563 17.2824 7.88159 17.1184C7.71756 16.9544 7.62528 16.732 7.625 16.5V7.5C7.62528 7.26802 7.71756 7.04563 7.88159 6.88159C8.04563 6.71756 8.26802 6.62528 8.5 6.625H15.5C15.732 6.62528 15.9544 6.71756 16.1184 6.88159C16.2824 7.04563 16.3747 7.26802 16.375 7.5V13C16.375 13.0995 16.3355 13.1948 16.2652 13.2652C16.1948 13.3355 16.0995 13.375 16 13.375C15.9005 13.375 15.8052 13.3355 15.7348 13.2652C15.6645 13.1948 15.625 13.0995 15.625 13V7.5C15.6246 7.46697 15.6113 7.4354 15.588 7.41204C15.5646 7.38868 15.533 7.37539 15.5 7.375H8.5C8.46697 7.37539 8.4354 7.38868 8.41204 7.41204C8.38868 7.4354 8.37539 7.46697 8.375 7.5V16.5C8.37539 16.533 8.38868 16.5646 8.41204 16.588C8.4354 16.6113 8.46697 16.6246 8.5 16.625H15.5C15.594 16.5876 15.6988 16.5884 15.7922 16.6271C15.8856 16.6658 15.9602 16.7394 16.0002 16.8323C16.0197 16.877 16.0301 16.9251 16.0307 16.9739C16.0314 17.0227 16.0223 17.0711 16.0041 17.1163C15.9858 17.1615 15.9588 17.2027 15.9245 17.2373C15.8901 17.272 15.8493 17.2994 15.8042 17.3181C15.7074 17.3564 15.6041 17.3757 15.5 17.375Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.375H9.75C9.65054 9.375 9.55516 9.33549 9.48483 9.26517C9.41451 9.19484 9.375 9.09946 9.375 9C9.375 8.90054 9.41451 8.80516 9.48483 8.73483C9.55516 8.66451 9.65054 8.625 9.75 8.625H14.25C14.3495 8.625 14.4448 8.66451 14.5152 8.73483C14.5855 8.80516 14.625 8.90054 14.625 9C14.625 9.09946 14.5855 9.19484 14.5152 9.26517C14.4448 9.33549 14.3495 9.375 14.25 9.375Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 11.375H9.75C9.65054 11.375 9.55516 11.3355 9.48483 11.2652C9.41451 11.1948 9.375 11.0995 9.375 11C9.375 10.9005 9.41451 10.8052 9.48483 10.7348C9.55516 10.6645 9.65054 10.625 9.75 10.625H14.25C14.3495 10.625 14.4448 10.6645 14.5152 10.7348C14.5855 10.8052 14.625 10.9005 14.625 11C14.625 11.0995 14.5855 11.1948 14.5152 11.2652C14.4448 11.3355 14.3495 11.375 14.25 11.375Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13.375H9.75C9.65054 13.375 9.55516 13.3355 9.48483 13.2652C9.41451 13.1948 9.375 13.0995 9.375 13C9.375 12.9005 9.41451 12.8052 9.48483 12.7348C9.55516 12.6645 9.65054 12.625 9.75 12.625H13C13.0995 12.625 13.1948 12.6645 13.2652 12.7348C13.3355 12.8052 13.375 12.9005 13.375 13C13.375 13.0995 13.3355 13.1948 13.2652 13.2652C13.1948 13.3355 13.0995 13.375 13 13.375Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.375H9.75C9.65054 15.375 9.55516 15.3355 9.48483 15.2652C9.41451 15.1948 9.375 15.0995 9.375 15C9.375 14.9005 9.41451 14.8052 9.48483 14.7348C9.55516 14.6645 9.65054 14.625 9.75 14.625H12.5C12.5995 14.625 12.6948 14.6645 12.7652 14.7348C12.8355 14.8052 12.875 14.9005 12.875 15C12.875 15.0995 12.8355 15.1948 12.7652 15.2652C12.6948 15.3355 12.5995 15.375 12.5 15.375Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.375C15.5303 17.375 15.0711 17.2357 14.6805 16.9747C14.29 16.7138 13.9855 16.3428 13.8058 15.9089C13.626 15.4749 13.579 14.9974 13.6706 14.5367C13.7623 14.076 13.9885 13.6528 14.3206 13.3206C14.6528 12.9885 15.076 12.7623 15.5367 12.6706C15.9974 12.579 16.4749 12.626 16.9089 12.8058C17.3428 12.9855 17.7138 13.29 17.9747 13.6805C18.2357 14.0711 18.375 14.5303 18.375 15C18.3743 15.6297 18.1238 16.2333 17.6786 16.6786C17.2333 17.1238 16.6297 17.3743 16 17.375ZM16 13.375C15.6786 13.375 15.3644 13.4703 15.0972 13.6489C14.83 13.8274 14.6217 14.0812 14.4987 14.3781C14.3757 14.6751 14.3435 15.0018 14.4062 15.317C14.4689 15.6322 14.6237 15.9218 14.851 16.149C15.0782 16.3763 15.3678 16.5311 15.683 16.5938C15.9982 16.6565 16.3249 16.6243 16.6219 16.5013C16.9188 16.3783 17.1726 16.17 17.3511 15.9028C17.5297 15.6356 17.625 15.3214 17.625 15C17.6245 14.5692 17.4531 14.1561 17.1485 13.8515C16.8439 13.5469 16.4308 13.3755 16 13.375Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 15.875C16.4507 15.8751 16.402 15.8654 16.3565 15.8465C16.311 15.8277 16.2696 15.8 16.2349 15.7651L15.7349 15.2651C15.6645 15.1948 15.625 15.0994 15.625 15V14C15.625 13.9005 15.6645 13.8052 15.7348 13.7348C15.8052 13.6645 15.9005 13.625 16 13.625C16.0995 13.625 16.1948 13.6645 16.2652 13.7348C16.3355 13.8052 16.375 13.9005 16.375 14V14.8447L16.7651 15.2349C16.8176 15.2873 16.8533 15.3541 16.8677 15.4269C16.8822 15.4996 16.8748 15.575 16.8464 15.6435C16.818 15.712 16.77 15.7706 16.7083 15.8118C16.6466 15.853 16.5742 15.875 16.5 15.875Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1082_24991",
    x1: 5.55719,
    y1: 0.531419,
    x2: 20.1251,
    y2: 24.9846,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CFB88D",
    style: {
      stopColor: "#CFB88D",
      stopColor: "color(display-p3 0.8118 0.7216 0.5529)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59462E",
    style: {
      stopColor: "#59462E",
      stopColor: "color(display-p3 0.3490 0.2745 0.1804)",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1082_24991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    },
    transform: "translate(7 6)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscationSummaryIcon);
export default __webpack_public_path__ + "static/media/transcationSummaryIcon.6cfb92cd766132cf9aeb3631517253b8.svg";
export { ForwardRef as ReactComponent };